import styled from 'styled-components'
import { Box, Text } from '../Shared/Base'
import { Circle, MapContainer, Polygon, TileLayer } from 'react-leaflet'
import { Fragment, useMemo } from 'react'
import { flatten, sum, unnest } from 'ramda'

const BoxMap = styled(Box)`
  .leaflet-container {
    height: 360px;
    width: 100wh;
  }
`

const MapZone = ({ zones, zone_id }) => {
  const alllatlng = useMemo(
    () =>
      flatten(zones.map(mz => mz.geometry.coordinates)).reduce((acc, e) => {
        if (!acc[0] || (acc[0] && acc[0].latitude)) {
          acc.unshift({ longitude: e })
        } else {
          acc[0].latitude = e
        }
        return acc
      }, []),
    [zones]
  )

  const initialRegion = useMemo(
    () => ({
      lat: sum(alllatlng.map(e => e.latitude)) / alllatlng.length,
      lng: sum(alllatlng.map(e => e.longitude)) / alllatlng.length
    }),
    [alllatlng]
  )

  return (
    <BoxMap>
      <MapContainer
        center={[initialRegion.lat, initialRegion.lng]}
        zoom={12}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {zones
          .filter(z => z.properties.id === zone_id)
          .map(zone => {
            const polygons =
              zone.geometry.type === 'Polygon'
                ? zone.geometry.coordinates
                : unnest(zone.geometry.coordinates)

            return (
              <Fragment key={zone.properties.id}>
                {polygons.map((positions, index) => (
                  <Polygon
                    key={index}
                    pathOptions={{
                      fillColor: '#B361B5',
                      fillOpacity: zone.properties.id === zone_id ? 0.33 : 0.11,
                      color: '#B361B5'
                    }}
                    positions={positions.map(pos => [pos[1], pos[0]])}
                  />
                ))}
              </Fragment>
            )
          })}
      </MapContainer>
    </BoxMap>
  )
}

export const AdMap = ({ ad }) => {
  if (!ad.lat || !ad.lng) {
    if (ad.quartier) {
      return (
        <>
          <Text className="fz-16" mb={20} mt="-10px">
            Cette annonce ne dispose pas d'une localisation précise, veuillez contacter l'agence.
          </Text>
          <MapZone zones={[ad.quartier]} zone_id={ad.quartier.properties.id} />
        </>
      )
    }

    if (ad.multizip) {
      return (
        <>
          <Text className="fz-16" mb={20} mt="-10px">
            Cette annonce ne dispose pas d'une localisation précise, veuillez contacter l'agence.
          </Text>
          <MapZone zones={ad.multizip.zone} zone_id={ad.postal_code} />
        </>
      )
    }

    return (
      <Text className="fz-16" mb={20} mt="-10px">
        Cette annonce ne dispose d'aucune information de localisation, veuillez contacter l'agence.
      </Text>
    )
  }

  return (
    <BoxMap>
      <MapContainer center={[ad.lat, ad.lng]} zoom={15} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Circle
          center={[ad.lat, ad.lng]}
          pathOptions={{ fillColor: '#B361B5', fillOpacity: 0.33, stroke: false }}
          radius={100}
        />
      </MapContainer>
    </BoxMap>
  )
}
